<template>
  <Page :page-name="pageName" :table="table" :pagination="pagination" :search-bar="searchBar">
    <div slot="activityCommentType" slot-scope="{scope}">
      <span>{{scope.activityCommentType | commentTypeFilter }}</span>
    </div>

    <div slot="isDelete" slot-scope="{scope}">
      <span>{{ scope.isDelete | publishStatusFilter }}</span>
    </div>

    <div slot="files" slot-scope="{scope}" style="display: flex;justify-content: center;">
      <el-image  v-if="scope.files.length" style="width: 59px; height: 34px" :src="scope.files[0]" :preview-src-list="scope.files"></el-image>
      <span v-else>暂无图片</span>
    </div>

    <template slot="table-operate" slot-scope="{scope}">
      <el-button type="text" @click="replyDetail(scope)" style="color:#00af84">回复详情</el-button>
      <el-button type="text" @click="delComment(scope)" style="color:red" :style="{color: scope.isDelete==0 ? 'red':'#00af84'}">{{scope.isDelete==0 ? '删除':'恢复'}}评论</el-button>
    </template>

    <Dialogs title="回复详情" :is-show-dialog="isShowReply" width="35%" @handleClick="handleClose" :noBorderTop="noBorderTop" :destroyOnClosen="true">
      <div slot="content" v-if="replayList.length" style="min-height: 200px;max-height: 500px;overflow: auto;">
        <ReplayComment v-for="(item, index) in replayList" :item="item" :key="index" :row="currentRow" :getReplyDetail="getReplyDetail"/>
      </div>
      <div slot="content" v-else>
        <div class="no-reply"><el-empty description="暂无回复"></el-empty></div>
      </div>
      <div slot="btns"></div>
    </Dialogs>
  </Page>
</template>

<script>
import Page from '@/components/Page.vue'
import Dialogs from '@/components/page/Dialogs.vue'
import { getCommentList, deleteComment, getCommentDetail } from '@/api/commentManage'
import ReplayComment from './replayComment.vue'
const initParams = {
  current: 0,
  size: 10,
  activityName: '',
  isDelete: '',
  publishStatus: ''
}

export default {
  components: {
    Page,
    Dialogs,
    ReplayComment
  },
  filters: {
    publishStatusFilter (val) {
      switch (val) {
        case 1:
          return '已删除'
        case 0:
          return '正常'
      }
    },
    commentTypeFilter (val) {
      switch (val) {
        case 1:
          return '活动评论'
        case 0:
          return '回复评论'
      }
    }
  },
  data () {
    return {
      activityId: '',
      isShowMark: false,
      noBorderTop: true,
      params: {...initParams},
      pageName: '评论管理',
      isShowReply: false,
      table: {
        selection: false, // 是否开启选择框
        actionWidth: 220,
        index: true,
        // disableKey: 'xxx', // 是否可勾选字段
        tableInfo: [{
          key: 'activityName',
          name: '活动名称',
          minWidth: 80
        }, {
          key: 'activityCommentType',
          name: '评论类型',
          minWidth: 80,
          type: 'custom'
        }, {
          key: 'publishUserName',
          name: '评论人',
          minWidth: 100
        }, {
          key: 'createTime',
          name: '评论时间',
          minWidth: 120
        }, {
          key: 'content',
          name: '评论内容',
          minWidth: 120
        }, {
          key: 'files',
          name: '展示图片',
          minWidth: 80,
          type: 'custom'
        }, {
          key: 'isDelete',
          name: '评论状态',
          minWidth: 80,
          type: 'custom'
        }],
        tableData: [],
        deleteList: (list) => {
          console.log(list)
        }
      },
      pagination: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        currentChange: (page) => {
          this.searchType(page)
        },
        sizeChange: (pageSize) => {
          this.params.size = pageSize
          this.searchType()
        }
      },
      searchBar: {
        list: [{
          type: 'input',
          prop: 'activityName',
          label: '活动名称',
          placeholder: '请输入活动标题'
        }, {
          type: 'select',
          prop: 'isDelete',
          label: '评论状态',
          options: [{
            value: 0,
            label: '正常'
          }, {
            value: 1,
            label: '已删除'
          }],
          placeholder: '请选择活动状态'
        }, {
          type: 'btn',
          text: '搜索',
          btnType: 'primary',
          callback: (params) => {
            this.params = { ...this.params, ...params }
            this.searchType(1)
          }
        }, {
          type: 'btn',
          text: '重置',
          isReset: true,
          btnType: 'primary',
          callback: this.resetList
        }]
      },
      replayList: [],
      currentRow: null
    }
  },
  async mounted () {
    this.initData()
  },
  methods: {
    removeNullParam (params) {
      for (const key in params) {
        if (params[key] !== 0 && !params[key]) {
          delete params[key]
        }
      }
      return params
    },
    async initData () {
      const { data = {} } = await getCommentList(this.removeNullParam(this.params))
      let { records = [], total = 0 } = data
      records.forEach(item => {
        item.files = item.files.map(urlItem => urlItem.fileUrl)
      })

      this.$set(this.table, 'tableData', records)
      this.$set(this.pagination, 'total', total)
    },
    delComment (row) {
      const txt = row.isDelete == 1 ? '恢复' : '删除'
      this.$confirm(`确定要${txt}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const newIsDelete = row.isDelete === 0 ? 1 : 0
        const params = {
          activityId: row.activityId,
          commentId: row.activityCommentId,
          isDelete: newIsDelete
        }
        try {
          await deleteComment(params)
          this.searchType(this.params.current)
        } catch (error) {
          console.log(error)
        }
      }).catch(() => {})
    },
    searchType (page = 0) {
      if (page) this.pagination.currentPage = page
      this.params.current = page
      this.initData()
    },
    resetList () {
      this.params = {...initParams}
      this.searchType()
    },
    replyDetail (row) {
      this.isShowReply = true
      this.currentRow = row
      this.getReplyDetail({activityCommentId: row.activityCommentId})
    },
    async getReplyDetail (id) {
      let {data = []} = await getCommentDetail(id)
      this.replayList = data
    },
    handleClose () {
      this.isShowReply = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .dialog-box {
    height: 70%;
  }
  .el-button + .el-button{
    margin-left: 0;
  }
  .no-reply{
    display: flex;
    justify-content: center;
    align-items: baseline;
    min-height: 200px;
  }
  ::v-deep .el-dialog .el-dialog__footer{
    padding: 0!important;
  }
  ::v-deep .el-dialog{
    min-width: 560px;
  }
</style>